import { makeStyles } from '@material-ui/core';

export const useStyle = makeStyles(theme => {
	const {
		palette,
		breakpoints: { down, up },
		spacing,
	} = theme;
	return {
		container: {
			paddingTop: spacing(7),
			paddingBottom: spacing(7),
			'& h2': {
				fontFamily: 'BodoniMT',
				marginBottom: spacing(4),
				[down('sm')]: { margin: '0 !important' },
			},
			'& .divider': {
				height: '4px',
				marginBottom: '50px',
				[down('sm')]: {
					margin: spacing(1, 0, 2.5, 0),
					width: '50%',
					height: '3px',
				},
			},
			[down('sm')]: {
				padding: 0,
			},
			'& .MuiButton-endIcon': {
				display: 'none',
			},
		},
		gridContainer: {
			marginTop: spacing(4),
		},
		article: {
			[up('md')]: { paddingLeft: spacing(10) },
			[down('sm')]: {
				paddingBottom: spacing(8),
			},
		},
		button: {
			fontFamily: 'Montserrat',
			width: '100%',
			fontSize: '20px',
			textTransform: 'none',
			borderRadius: '2px',
			border: '2px solid',
			marginBottom: spacing(2),
			padding: '12px 0',
			'&:hover': {
				backgroundColor: palette.primary.main,
				color: 'white',
			},
			[down('sm')]: {
				fontSize: '18px',
				padding: '6px 0',
				border: '1px solid',
				'& .MuiButton-label': {
					fontSize: '1rem',
				},
			},
		},
		activeButton: {
			'& $button': {
				backgroundColor: palette.primary.main,
				color: 'white',
				[down('sm')]: {
					background: 'none',
					color: palette.primary.main,
					borderColor: palette.action.main,
				},
			},
			'& .MuiButton-endIcon': {
				display: 'flex',
				color: palette.action.main,
				alignItems: 'center',
			},
		},
		swiperContainer: {
			marginBottom: spacing(2.5),
		},
		leftGrid: {
			'& > h2': {
				fontFamily: 'BodoniMT',
				fontSize: '2rem',
				marginBottom: spacing(4),
			},
		},
	};
});
